const VertexShader = require('./VertexShader.glsl');
const FragmentShader = require('./FragmentShader.glsl');

const PARAMS = {
    vertexShader: VertexShader,
    fragmentShader: FragmentShader,
    uniforms: {
        transitionTimer: {
            name: "uTransitionTimer",
            type: "1f",
            value: 0,
        },
    },
};

// @ts-ignore
import { Curtains, Plane } from "curtainsjs";

export { PARAMS, Curtains, Plane }